import { MUTATION } from '@/store/CONSTANTS';

export default function dashboardPlugin(store) {
  store.subscribe((mutation, state) => {
    if (mutation.type === MUTATION.DASHBOARD.SET_EXPANDED_DEAL && mutation.payload) {
      const { payload: expandedDeal } = mutation;
      const { status_groups: statusGroups } = state.dashboard.dashboard;

      const oldStatusGroupIndex = statusGroups.findIndex(({ deals }) =>
        deals.find(({ uid }) => uid === expandedDeal.uid),
      );

      const hasDealStatusGroupChanged =
        statusGroups[oldStatusGroupIndex].name !== expandedDeal.status_group;

      if (hasDealStatusGroupChanged) {
        const newStatusGroupIndex = statusGroups.findIndex(
          ({ name }) => name === expandedDeal.status_group,
        );
        const dealIndexInNewStatusGroup = statusGroups[newStatusGroupIndex].deals.length;
        store.commit(MUTATION.DASHBOARD.UPDATE_STATUS_GROUP_DEAL, {
          dealIndex: dealIndexInNewStatusGroup,
          dealData: expandedDeal,
        });
        const oldStatusGroupFilteredDeals = statusGroups[oldStatusGroupIndex].deals.filter(
          ({ uid }) => uid !== expandedDeal.uid,
        );
        store.commit(MUTATION.DASHBOARD.SET_STATUS_GROUP, {
          ...statusGroups[oldStatusGroupIndex],
          deals: oldStatusGroupFilteredDeals,
          deals_count: oldStatusGroupFilteredDeals.length,
        });
      } else {
        const dealIndexInStatusGroup = statusGroups[oldStatusGroupIndex].deals.findIndex(
          ({ uid }) => uid === expandedDeal.uid,
        );
        store.commit(MUTATION.DASHBOARD.UPDATE_STATUS_GROUP_DEAL, {
          dealIndex: dealIndexInStatusGroup,
          dealData: expandedDeal,
        });
      }
    }
  });
}
